export default __webpack_public_path__ + "static/media/icono_mujer.b6ead916.svg";